import { Link } from "react-router-dom";
import { AdultScreen, AdultHeader, Content } from "../components/Layout.js";
import { Card } from "../components/Card.js";

export function NotFoundPage() {
  return (
    <AdultScreen>
      <AdultHeader title="Página no encontrada" />
      <Content>
        <Card>
          <h2>404</h2>
          <p>La página que buscas no existe o fue movida.</p>
          <Link to="/" style={{ display: "inline-block", marginTop: 12, fontWeight: 700 }}>
            ← Volver al inicio
          </Link>
        </Card>
      </Content>
    </AdultScreen>
  );
}
